import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';

type TTestingMethod = 'all' | 'sast-dast' | 'sast' | 'dast';

type TTestingMethodCounts = {
  all: number;
  sastDast: number;
  sast: number;
  dast: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportTestingMethodsFilters',
  props: {
    initialValue: null,
    testingMethodCounts: { default: () => ({ all: 0, sastDast: 0, sast: 0, dast: 0 }) }
  },
  emits: ["filterChanged"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'filterChanged', filter: TTestingMethod): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { initialValue: TTestingMethod, testingMethodCounts: TTestingMethodCounts };





const filterContainer = ref<HTMLElement | null>(null);
const all = ref<HTMLButtonElement | null>(null);
const sastDast = ref<HTMLButtonElement | null>(null);
const sast = ref<HTMLButtonElement | null>(null);
const dast = ref<HTMLButtonElement | null>(null);

const buttonRefs: Record<TTestingMethod, typeof all> = {
  all,
  'sast-dast': sastDast,
  sast,
  dast,
};

const activeFilter = ref<TTestingMethod>(props.initialValue);
const activeItemStyle = ref<Record<string, string | number>>({
  transform: 'translateX(0px)',
  width: '0px',
  opacity: 0,
});
let resizeTimeout: ReturnType<typeof setTimeout> | null = null;

function setActiveItemStyle({ shouldScroll = true }: { shouldScroll?: boolean } = {}) {
  nextTick(() => {
    const activeButton = buttonRefs[activeFilter.value].value;
    if (!activeButton || !filterContainer.value) return;

    const containerRect = filterContainer.value.getBoundingClientRect();
    const buttonRect = activeButton.getBoundingClientRect();
    const padding = parseFloat(window.getComputedStyle(filterContainer.value).paddingLeft) || 0;

    const offsetX =
      buttonRect.left - containerRect.left - padding + filterContainer.value.scrollLeft;

    activeItemStyle.value = {
      transform: `translateX(${offsetX}px)`,
      width: `${buttonRect.width}px`,
      height: `${buttonRect.height}px`,
    };

    if (window.innerWidth > 768 || !shouldScroll) return;

    setTimeout(() => {
      activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }, 300);
  });
}

function setActiveFilter(filter: TTestingMethod) {
  const countKey = filter === 'sast-dast' ? 'sastDast' : filter;
  if (props.testingMethodCounts[countKey] === 0) return;

  activeFilter.value = filter;
  setActiveItemStyle();
  emit('filterChanged', filter);
}

function handleResize() {
  if (resizeTimeout) clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => setActiveItemStyle({ shouldScroll: false }), 150);
}

watch(
  () => props.initialValue,
  (newVal) => {
    activeFilter.value = newVal;
    setActiveItemStyle();
  }
);

onMounted(async () => {
  await nextTick();

  requestAnimationFrame(() => {
    setActiveItemStyle({ shouldScroll: false });
  });
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  if (resizeTimeout) clearTimeout(resizeTimeout);
});

return { __sfc: true,props, emit, filterContainer, all, sastDast, sast, dast, buttonRefs, activeFilter, activeItemStyle, resizeTimeout, setActiveItemStyle, setActiveFilter, handleResize }
}

})